import { render, staticRenderFns } from "./data-view-setting-dialog.vue?vue&type=template&id=64d26935&"
import script from "./data-view-setting-dialog.vue?vue&type=script&lang=js&"
export * from "./data-view-setting-dialog.vue?vue&type=script&lang=js&"
import style0 from "./data-view-setting-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports